import React from "react";
import CptShimmerBlock from "../CptShimmerBlock";

const NaPatientTableShimmer = ({ rowCount = 5 }) => (
  <>
    <div className="chart-header-modern mpr-shimmer-header-row">
      <CptShimmerBlock className="mpr-shimmer-icon-block" />
      <div className="chart-header-copy-modern">
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--subtitle" />
      </div>
    </div>

    <div className="mpr-shimmer-toolbar">
      <CptShimmerBlock className="mpr-shimmer-search" />
      <CptShimmerBlock className="mpr-shimmer-export" />
    </div>

    <div className="na-shimmer-table-shell">
      <div className="table-responsive na-shimmer-table-wrap">
        <table className="mpr-patient-table na-shimmer-table">
          <colgroup>
            <col className="na-shimmer-col patient" />
            <col className="na-shimmer-col enrolled" />
            <col className="na-shimmer-col uploaded" />
            <col className="na-shimmer-col provider" />
            <col className="na-shimmer-col org" />
            <col className="na-shimmer-col days" />
            <col className="na-shimmer-col cpt" />
            <col className="na-shimmer-col action" />
          </colgroup>
          <thead>
            <tr>
              {Array.from({ length: 8 }).map((_, idx) => (
                <th key={`th-${idx}`}>
                  <CptShimmerBlock
                    className={`mpr-shimmer-line ${idx === 0 || idx === 6 ? "mpr-shimmer-line--md" : "mpr-shimmer-line--sm"}`}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rowCount }).map((_, rowIdx) => (
              <tr key={`tr-${rowIdx}`}>
                <td>
                  <div className="mpr-shimmer-cell-profile">
                    <CptShimmerBlock className="mpr-shimmer-avatar" />
                    <div className="mpr-shimmer-cell-lines">
                      <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
                      <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
                    </div>
                  </div>
                </td>
                <td>
                  <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
                </td>
                <td>
                  <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
                </td>
                <td>
                  <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
                </td>
                <td>
                  <div className="mpr-shimmer-cell-org">
                    <CptShimmerBlock className="mpr-shimmer-org-icon" />
                    <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
                  </div>
                </td>
                <td>
                  <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--badge" />
                </td>
                <td>
                  <div className="mpr-shimmer-chip-row">
                    <CptShimmerBlock className="mpr-shimmer-chip" />
                    <CptShimmerBlock className="mpr-shimmer-chip" />
                    <CptShimmerBlock className="mpr-shimmer-chip" />
                  </div>
                </td>
                <td>
                  <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--action" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="na-shimmer-pagination">
        <CptShimmerBlock className="mpr-shimmer-pagination-text" />
        <div className="na-shimmer-pagination-right">
          {[1, 2, 3, 4].map((item) => (
            <CptShimmerBlock key={item} className="mpr-shimmer-pagination-btn" />
          ))}
        </div>
      </div>
    </div>
  </>
);

export default NaPatientTableShimmer;
